/**
 * Google Analytics utility
 * Only initializes when REACT_APP_GA_MEASUREMENT_ID is set. Skips initialization in
 * development unless REACT_APP_GA_ENABLE_DEV is also set.
 */

// Initialize Google Analytics
export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  
  // Only initialize if measurement ID is provided
  if (!measurementId) {
    console.log('Google Analytics: No measurement ID provided');
    return;
  }

  // Skip in development unless explicitly enabled
  const enableDevGA = process.env.REACT_APP_GA_ENABLE_DEV === 'true';
  if (process.env.NODE_ENV === 'development' && !enableDevGA) {
    console.log('Google Analytics: Disabled in development');
    return;
  }

  // Check for cookie consent (GDPR compliance)
  // TODO: Uncomment this when cookie consent banner is fully integrated
  /*
  const cookieConsent = localStorage.getItem('cookieConsent');
  if (cookieConsent !== 'accepted') {
    console.log('Google Analytics: Waiting for cookie consent');
    return;
  }
  */

  // Prevent re-initialization if gtag is already defined or script already exists
  if (window.gtag || document.querySelector(`script[src*="googletagmanager.com/gtag/js"]`)) {
    console.log('Google Analytics: Already initialized');
    return;
  }

  // Initialize dataLayer (preserve existing if Google Tag Manager or other analytics are present)
  window.dataLayer = window.dataLayer || [];
  
  // Define gtag function and make it globally accessible
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  // Load gtag script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  script.onerror = () => {
    console.error('Google Analytics: Failed to load script (ad blocker, network issue, or CSP restriction)');
    window.__GA_LOAD_FAILED = true;
  };
  document.head.appendChild(script);

  window.gtag('js', new Date());
  window.gtag('config', measurementId);

  // Only log in development
  if (process.env.NODE_ENV === 'development') {
    console.log('Google Analytics initialized:', measurementId);
  }
};

// Track page views (for React Router)
export const trackPageView = (path) => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  
  if (window.gtag && measurementId) {
    window.gtag('config', measurementId, {
      page_path: path,
    });
  }
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};
